__turbopack_context__.v({
  "addCustomItem": "sIBS1q_addCustomItem",
  "appcard": "sIBS1q_appcard",
  "appcardlist": "sIBS1q_appcardlist",
  "card": "sIBS1q_card",
  "cardHeader": "sIBS1q_cardHeader",
  "cardTitle": "sIBS1q_cardTitle",
  "cards": "sIBS1q_cards",
  "check": "sIBS1q_check",
  "checks": "sIBS1q_checks",
  "close": "sIBS1q_close",
  "content": "sIBS1q_content",
  "costumizeLabel": "sIBS1q_costumizeLabel",
  "ctrl": "sIBS1q_ctrl",
  "dialogtitle": "sIBS1q_dialogtitle",
  "fill": "sIBS1q_fill",
  "form": "sIBS1q_form",
  "label": "sIBS1q_label",
  "list": "sIBS1q_list",
  "outercontent": "sIBS1q_outercontent",
  "overlay": "sIBS1q_overlay",
  "result": "sIBS1q_result",
  "resultcard": "sIBS1q_resultcard",
  "resultform": "sIBS1q_resultform",
  "step0": "sIBS1q_step0",
  "summaryCard": "sIBS1q_summaryCard",
  "summaryGrid": "sIBS1q_summaryGrid",
  "table": "sIBS1q_table",
  "tag": "sIBS1q_tag",
  "title": "sIBS1q_title",
  "top": "sIBS1q_top",
});
